
import { useAuth } from "@/components/AuthProvider";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UpgradeBannerProps {
  onPricingClick: () => void;
  onLoginClick: () => void;
}

export const UpgradeBanner = ({ onPricingClick, onLoginClick }: UpgradeBannerProps) => {
  const { user } = useAuth();

  // Don't render the banner if user is authenticated
  if (user) return null;

  return (
    <div className="relative z-50">
      <div className="absolute inset-x-0 top-0">
        {/* Background layers */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#E5DEFF] to-white backdrop-blur-[2px]" />
        <div className="absolute inset-0 bg-[url('/grid.png')] opacity-[0.02]" />
        <div className="absolute inset-x-0 bottom-0 h-[1px] bg-gray-100" />
        
        {/* Content */}
        <div className="relative h-12 px-6 max-w-screen-2xl mx-auto flex items-center justify-center">
          <div className="flex items-center gap-4">
            <Sparkles className="h-5 w-5 text-purple-500" />
            <p className="text-[15px] text-gray-600 font-light">
              Unlock AI analysis, unlimited projects, and more
            </p>
            <Button 
              onClick={onPricingClick}
              size="sm"
              className="bg-purple-600 hover:bg-purple-500 text-white rounded-full px-6 py-0.5 h-7 text-sm font-normal transition-colors"
            >
              Start Free Trial
            </Button>
            <button 
              onClick={onLoginClick}
              className="text-[15px] text-purple-600 font-normal hover:text-purple-500 transition-colors"
            >
              or log in
            </button>
          </div>
        </div>
      </div>
      <div className="h-12" /> {/* Spacer to prevent content overlap */}
    </div>
  );
}
